import React, { useState, useEffect } from 'react';

const RotationPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const checkRotation = () => {
      const isTablet = window.matchMedia('(max-width: 768px) and (max-width: 1200px)').matches;
      setShowPrompt(isTablet);
    };

    checkRotation(); // Check on component mount

    window.addEventListener('resize', checkRotation); // Listen for resize events

    return () => {
      window.removeEventListener('resize', checkRotation); // Clean up the event listener
    };
  }, []);

  if (showPrompt) {
    return (
      <div className="rotation-prompt">
        <p>Please enable screen rotation to landscape mode for the best experience.</p>
        {/* You can customize the styling and content of the prompt here */}
      </div>
    );
  } else {
    return null;
  }
};

export default RotationPrompt;
